import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterComponent } from './auth/register/register.component';
import { LoginComponent } from './auth/login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { TesmonialSliderComponent } from './home/tesmonial-slider/tesmonial-slider.component';
import { FounderMsgComponent } from './founder-msg/founder-msg.component';
import { MomentMatComponent } from './moment-mat/moment-mat.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { HomeMainComponent } from './home-main/home-main.component'
import { NavbarComponent } from './navbar/navbar.component';
import { MainContactUsComponent } from './main-contact-us/main-contact-us.component'
import { CareerComponent } from './career/career.component';
import { GalleryComponent } from './gallery/gallery.component'
import { ProgramComponent } from './program/program.component';
import { ProgramDetailsComponent } from './program-details/program-details.component';
import { EventComponent } from './event/event.component';
import { DiseaseSliderComponent } from './home/disease-slider/disease-slider.component';
import { ProgramDdanceComponent } from './program-ddance/program-ddance.component';
import { ProgramDdramaticComponent } from './program-ddramatic/program-ddramatic.component';
import { ProgramDgymnasticsComponent } from './program-dgymnastics/program-dgymnastics.component';
import { ProgramDmusicComponent } from './program-dmusic/program-dmusic.component';
import { ProgramDpotteryComponent } from './program-dpottery/program-dpottery.component';
import { ProgramDteakwondoComponent } from './program-dteakwondo/program-dteakwondo.component';
import { ProgramDyogaComponent } from './program-dyoga/program-dyoga.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then( m => m.HomeModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomeModule)
  },
  { path: 'register', component:RegisterComponent},
  { path: 'login', component:LoginComponent},
  { path: 'founderMsg', component:FounderMsgComponent},
  { path: 'momentMat', component:MomentMatComponent}, 
  { path: 'contactUs', component:ContactUsComponent}, 
  { path: 'homeMain', component: HomeMainComponent}, 
  { path: 'navbar', component: NavbarComponent}, 
  { path: 'aboutUs', component: AboutUsComponent}, 
  { path: 'mainContactUs', component: MainContactUsComponent}, 
  { path: 'career', component: CareerComponent}, 
  { path: 'gallery', component: GalleryComponent}, 
  { path: 'event', component: EventComponent}, 
  { path: 'home', component: DiseaseSliderComponent}, 
  { path: 'program', component: ProgramComponent}, 
  { path: 'programDetails', component: ProgramDetailsComponent}, 
  { path: 'programDdance', component: ProgramDdanceComponent}, 
  { path: 'programDdramatic', component: ProgramDdramaticComponent}, 
  { path: 'programDgymnastics', component: ProgramDgymnasticsComponent}, 
  { path: 'programDmusic', component: ProgramDmusicComponent}, 
  { path: 'programDpottery', component: ProgramDpotteryComponent}, 
  { path: 'programDteakwondo', component: ProgramDteakwondoComponent}, 
  { path: 'programDyoga', component: ProgramDyogaComponent}, 
  {
    path: 'product-detail/:title/:id',
    loadChildren: () => import('./productdetails/productdetails.module').then( m => m.ProductdetailsModule)
  },
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule)
  },
  {
    path: 'productlist',
    loadChildren: () => import('./productlist/productlist.module').then( m => m.ProductlistModule)
  },
  {
    path: 'diseaselist',
    loadChildren: () => import('./diseaselist/diseaselist.module').then( m => m.DiseaselistModule)
  },
  {
    path: 'gallary',
    loadChildren: () => import('./gallary/gallary.module').then( m => m.GallaryModule)
  },
  {
    path: 'contactus',
    loadChildren: () => import('./appointment/appointment.module').then( m => m.AppointmentModule)
  },
  {
    path: 'disease-detail/:title/:id',
    loadChildren: () => import('./diseasedetails/diseasedetails.module').then( m => m.DiseasedetailsModule)
  },
  {
    path: 'characteristics',
    loadChildren: () => import('./characteristics/characteristics.module').then( m => m.CharacteristicsModule)
  },
  {
    path: 'characteristics-detail/:title/:id',
    loadChildren: () => import('./characteristicsdetails/characteristicsdetails.module').then( m => m.CharacteristicsdetailsModule)
  },
  {
    path:'achievements',
  loadChildren:()=>import('./achievements/achievements.module').then(m=>m.AchievementsModule)
  },
  {
  path:'ourteam',
  loadChildren:()=>import('./ourteam/ourteam.module').then(m=>m.OurteamModule)
  },
  {
    path: 'search/:query',
    loadChildren: () => import('./search/search.module').then( m => m.SearchModule)
  },
  {
    path:'event',
    loadChildren:() => import('./events/events.module').then(m=>m.EventsModule)
  },

  {
    path:'vision',
    loadChildren:()=> import('./vision/vision.module').then(m=>m.VisionModule)
  },
  {
    path:'casestudy',
    loadChildren:()=>import('./casestudy/casestudy.module').then(m=>m.CasestudyModule)

  },
  {
    path:'whyus',
    loadChildren:()=>import('./whyus/whyus.module').then(m=>m.WhyusModule)
  },
  {
    path:'successtory',
    loadChildren:()=>import('./successstorydisease/successstorydisease.module').then(m=>m.SuccessstorydiseaseModule)
  },
  { path: 'profile', component: ProfileComponent},
  {
    path:'testmonial',
    component: TesmonialSliderComponent
  },
  {
    path: 'orderdetail',
    loadChildren: () => import('./orderdetail/orderdetail.module').then(m => m.OrderdetailModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload',scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
